import script from "./PriceRate.vue?vue&type=script&lang=ts&setup=true"
export * from "./PriceRate.vue?vue&type=script&lang=ts&setup=true"

import "./PriceRate.vue?vue&type=style&index=0&id=97a3e30c&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-97a3e30c"]])

export default __exports__